module.exports = __webpack_public_path__ + "static/media/gallery4.f8f35e54.jpg";